import React from 'react';

import { ConfigProvider } from 'antd';

export interface ConfigProviderComponentProps {
    theme?: any;
    children: React.ReactNode;
}

const ConfigProviderComponent = ({ theme, ...props }: ConfigProviderComponentProps) => {
    return (
        <ConfigProvider theme={theme}>
            {props.children}
        </ConfigProvider>
    );
};

export default ConfigProviderComponent;
